import { useState } from "react";

const useIsUnloading = () => {
  const [isUnloading, setIsUnloading] = useState(false);
  window.addEventListener("beforeunload", () => setIsUnloading(true));

  return isUnloading;
};

export default useIsUnloading;
